import { Component } from 'react';

import withInfiniteScroll, {
  ArrayDataSource,
} from '@skyscanner/backpack-web/bpk-component-infinite-scroll';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import ImageList from './ImageList';

import type { ImagesGalleryItem } from '../../types';
import type { Maybe } from '@shared/types/utils';

import STYLES from './MediaWall.module.scss';

type Props = {
  items: ImagesGalleryItem[];
  toggleView: Function;
  selectedFilter?: Maybe<string>;
};

const cls = cssModules(STYLES);
const ELEMENTS_PER_SCROLL = 6;

class MediaWall extends Component<Props> {
  static defaultProps = { selectedFilter: null };

  shouldComponentUpdate(nextProps: Props) {
    const { items: [{ category: curCategory }] = [{ category: '' }] } =
      this.props;

    const { items: [{ category: nextCategory }] = [{ category: '' }] } =
      nextProps;

    return (
      this.props.selectedFilter !== nextProps.selectedFilter ||
      curCategory !== nextCategory ||
      this.props.items.length !== nextProps.items.length
    );
  }

  render() {
    const { items, toggleView } = this.props;

    const InfiniteList = withInfiniteScroll(ImageList);
    const dataSource = new ArrayDataSource(items);

    return (
      <div className={cls('MediaWall')} data-test-id="media-wall">
        <InfiniteList
          dataSource={dataSource}
          initiallyLoadedElements={ELEMENTS_PER_SCROLL}
          elementsPerScroll={ELEMENTS_PER_SCROLL}
          toggleView={toggleView}
          loaderIntersectionTrigger="half"
        />
      </div>
    );
  }
}

export default MediaWall;
